import { calculateMinutesDuration } from '@/clientState/commonFunctions';
import type { TechnicalStop } from '@/generated/graphql';

export interface TechnicalStopExtended extends TechnicalStop {
  duration: number;
}
export default function technicalStopoverResolver(
  technicalStop: TechnicalStop
): TechnicalStopExtended {
  const duration = calculateMinutesDuration(
    technicalStop.departureDate,
    technicalStop.arrivalDate
  );
  return {
    ...technicalStop,
    duration,
  };
}
